import {API_RESOURCES, createApiReadAction} from '../../utils/api';

const initialState = {
	configuration: {}
};

const GET_FEATURE_CONFIGURATIONS = 'FeatureConfigurations';

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case GET_FEATURE_CONFIGURATIONS: {
			return action.response;
		}
		default:
			return state;
	}
}

export function getFeatureConfigurations() {
	return createApiReadAction(GET_FEATURE_CONFIGURATIONS, {
		[API_RESOURCES.FEATURE_CONFIGURATIONS]: undefined
	});
}
